
import React from 'react';
import SkillsCore from '../skills/SkillsCore';

interface SkillsFormProps {
  skills: string[] | null;
  newSkill: string;
  profession: string | null;
  onNewSkillChange: (value: string) => void;
  onAddSkill: () => void;
  onRemoveSkill: (index: number) => void;
}

const SkillsForm = (props: SkillsFormProps) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">Skills</h3>
      <SkillsCore {...props} showLabel={true} />
    </div>
  );
};

export default SkillsForm;
